import { Component, Input, ViewChild } from '@angular/core';
import { ReportingService } from '../../../models/reporting/reportingService';
import { BarChartComponent } from '../../ui/graphing/bar-chart/bar-chart.component';

@Component({
  selector: 'app-transactions-chart',
  templateUrl: './transactions-chart.component.html',
  standalone: false,
})
export class TransactionsChartComponent {
  @ViewChild('theChart') theChart: BarChartComponent | undefined;

  @Input() chartType: string = 'bar'; // bar, line
  @Input() merchantId: string | undefined = undefined;
  @Input() interval: string = 'month'; // day, month
  @Input() duration: number = 12;

  data: any[] = [];

  constructor(private reportingService: ReportingService) {}

  ngOnInit() {}

  ngAfterViewInit() {
    this.reportingService
      .getTransactionsReportData(this.merchantId, this.interval, this.duration)
      .then((reportData) => {
        /* // for UI demo only!
      let reportData = new Array(1);
      reportData[0] = {label: "OCT '23", value: 296};
      reportData[1] = {label: "NOV '23", value: 792};
      reportData[2] = {label: "DEC '23", value: 663};
      reportData[3] = {label: "JAN '24", value: 922};
      reportData[4] = {label: "FEB '24", value: 392};
      reportData[5] = {label: "MAR '24", value: 255};
      reportData[6] = {label: "APR '24", value: 148};
      reportData[7] = {label: "MAY '24", value: 615};
      reportData[8] = {label: "JUN '24", value: 631};
      reportData[9] = {label: "JUL '24", value: 536};
      reportData[10] = {label: "AUG '24", value: 180};
      reportData[11] = {label: "SEP '24", value: 476};
      reportData[12] = {label: "OCT '24", value: 105};
      */

        if (this.theChart) {
          let newData: any[] = [];

          for (var i = 0; i < reportData.length; i++) {
            newData.push({
              year: reportData[i].label,
              count: reportData[i].value,
            });
          }

          this.theChart.setData(newData, { default: '#22dd88' });
        }
      });
  }
}
